import { APP_BUNDLES, EXAM_TITLES, BUNDLE_APP_NAME, IS_BUNDLE_APP, PAYWALL_COPY } from './_shared/brand-data'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_SIE,
  PRACTICE_TEST as PRACTICE_TEST_SIE,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_SIE,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_SIE,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_SIE,
} from './sie'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_SERIES6,
  PRACTICE_TEST as PRACTICE_TEST_SERIES6,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_SERIES6,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_SERIES6,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_SERIES6,
} from './series6'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_SERIES7,
  PRACTICE_TEST as PRACTICE_TEST_SERIES7,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_SERIES7,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_SERIES7,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_SERIES7,
} from './series7'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_SERIES63,
  PRACTICE_TEST as PRACTICE_TEST_SERIES63,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_SERIES63,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_SERIES63,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_SERIES63,
} from './series63'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_SERIES65,
  PRACTICE_TEST as PRACTICE_TEST_SERIES65,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_SERIES65,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_SERIES65,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_SERIES65,
} from './series65'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_SERIES66,
  PRACTICE_TEST as PRACTICE_TEST_SERIES66,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_SERIES66,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_SERIES66,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_SERIES66,
} from './series66'

import { IMAGES } from "../lzapp_web_common_code/assets";
import { USER_DEAFULT_KEY } from "../lzapp_web_common_code/constant/event";

export { APP_BUNDLES, BUNDLE_APP_NAME, IS_BUNDLE_APP, PAYWALL_COPY }

export const APP_DATA = {
  DISPLAY_APP_NAME: 'FINRA Securities Exam Prep',
};

export const GET_APP_NAME = (SELECTED_BUNDLE) => {
  return EXAM_TITLES[SELECTED_BUNDLE] || 'SIE';
};

export const GET_EXAM_DISPLAY_TITLE = (SELECTED_BUNDLE) => {
  return EXAM_TITLES[SELECTED_BUNDLE] || 'SIE';
}

const APP_NAME = "SECURITIES";

export const GET_APP_NAME_FOR_COLLECTION = async () => {
  const result = localStorage.getItem(USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS);
  const bundle = APP_BUNDLES.find(b => b.key === result);
  return bundle ? bundle.bundle_firebase_collection_name : 'SIE';
};

const QUESTION_VERSIONS = {
  'sie': QUESTION_VERSION_OF_JSON_SIE,
  'series6': QUESTION_VERSION_OF_JSON_SERIES6,
  'series7': QUESTION_VERSION_OF_JSON_SERIES7,
  'series63': QUESTION_VERSION_OF_JSON_SERIES63,
  'series65': QUESTION_VERSION_OF_JSON_SERIES65,
  'series66': QUESTION_VERSION_OF_JSON_SERIES66
};

export const GET_QUESTION_VERSION_OF_JSON = async () => {
  const result = localStorage.getItem(USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS);
  return QUESTION_VERSIONS[result] || QUESTION_VERSION_OF_JSON_SIE;
};

export const app_url = "https://www.learnzapp.com/apps/securities";

const PRACTICE_TESTS = {
  'sie': PRACTICE_TEST_SIE,
  'series6': PRACTICE_TEST_SERIES6,
  'series7': PRACTICE_TEST_SERIES7,
  'series63': PRACTICE_TEST_SERIES63,
  'series65': PRACTICE_TEST_SERIES65,
  'series66': PRACTICE_TEST_SERIES66
};

export const GET_PRACTICE_TEST = (SELECTED_BUNDLE) => {
  return PRACTICE_TESTS[SELECTED_BUNDLE] || PRACTICE_TEST_SIE;
};

const DOMAIN_LISTS = {
  'sie': APP_DOMAIN_LIST_SIE,
  'series6': APP_DOMAIN_LIST_SERIES6,
  'series7': APP_DOMAIN_LIST_SERIES7,
  'series63': APP_DOMAIN_LIST_SERIES63,
  'series65': APP_DOMAIN_LIST_SERIES65,
  'series66': APP_DOMAIN_LIST_SERIES66
};

export const GET_APP_DOMAIN_LIST = (SELECTED_BUNDLE) => {
  return DOMAIN_LISTS[SELECTED_BUNDLE] || APP_DOMAIN_LIST_SIE;
};

const STUDY_QUESTION_MENUS = {
  'sie': GET_STUDY_QUESTION_MENU_SIE,
  'series6': GET_STUDY_QUESTION_MENU_SERIES6,
  'series7': GET_STUDY_QUESTION_MENU_SERIES7,
  'series63': GET_STUDY_QUESTION_MENU_SERIES63,
  'series65': GET_STUDY_QUESTION_MENU_SERIES65,
  'series66': GET_STUDY_QUESTION_MENU_SERIES66
};

export const GET_STUDY_QUESTION_MENU = (SELECTED_BUNDLE) => {
  const menuFn = STUDY_QUESTION_MENUS[SELECTED_BUNDLE] || GET_STUDY_QUESTION_MENU_SIE;
  let menu = menuFn();

  if (IS_TEST_MODE) {
    menu.push({
      title: 'All Questions (Testing)',
      key: 'all_questions_testing',
      image: IMAGES?.ic_flash_topic,
      menu: null,
      requires_subscription: false
    });
  }

  return menu;
};

const FLASH_CARD_MENUS = {
  'sie': GET_FLASH_CARD_MENU_SIE,
  'series6': GET_FLASH_CARD_MENU_SERIES6,
  'series7': GET_FLASH_CARD_MENU_SERIES7,
  'series63': GET_FLASH_CARD_MENU_SERIES63,
  'series65': GET_FLASH_CARD_MENU_SERIES65,
  'series66': GET_FLASH_CARD_MENU_SERIES66
};

export const GET_FLASH_CARD_MENU = (SELECTED_BUNDLE) => {
  const menuFn = FLASH_CARD_MENUS[SELECTED_BUNDLE] || GET_FLASH_CARD_MENU_SIE;
  return menuFn();
};

export const GET_ARTICLE_MENU = () => {
  return [];
};

export const GET_TUTORIALS = () => {
  return [
    {
      title: `FINRA Securities Exam Prep`,
      image: IMAGES.slide_1,
      description:
        "Ace your exam on the first try with this comprehensive study app! \nOver 5000 practice questions to help you succeed in FINRA Securities Exams \nSIE, Series 6, Series 7, Series 63, Series 65, and Series 66",
    },
    {
      title: "Readiness Score",
      image: IMAGES.slide_2,
      description:
        "The readiness score in the app provides a quick and easy way for you to assess your level of preparedness for the real exam, and to identify areas where you need to focus your study efforts in order to improve their chances of success.",
    },
    {
      title: "Practice makes Perfect!!",
      image: IMAGES.slide_3,
      description:
        "Create your own custom tests by choosing the topics and the number of questions or take pre-built practice tests and mock exams. \nThe custom test engine creates personalized tests with new and your weakest questions.",
    },
    {
      title: "Track your Progress",
      image: IMAGES.slide_4,
      description:
        "Keep track of your progress through the study materials and see how much you have left to complete. \nView the history of your completed tests and re-take any of them as needed.",
    },
    {
      title: "Available on-the-go",
      image: IMAGES.slide_5,
      description:
        "The app is available on both iOS and Android devices, so you study anywhere, anytime. \nYou can seamlessly access and work with your data across multiple devices.",
    },
  ];
};

export const STRING = {
  share_message:
    "Hey there, I am using this app to prepare for FINRA Securities certification exam. I think you will find it very useful. Check it out " +
    app_url,
};

export const THIRD_PARTY_CONFIG = {
  STRIPE_PRODUCT_ID: process.env.REACT_APP_STRIPE_PRODUCT_ID,
};

// Display name for the Stripe product on user-facing invoices.
// Each brand build sets its own value (matches the product name in the Stripe dashboard).
export const STRIPE_PRODUCT_DISPLAY_NAME = 'FINRA Securities Exam Prep App';

export const PAYWALL_COLUMNS = [
  { key: 'questions', label: 'QUESTIONS' },
  { key: 'practiceTests', label: 'PRACTICE TESTS' },
];

export const IS_TEST_MODE = false;
export const IS_VISIBLE_COMMUNITY = true;

// Post-sign-in welcome modal title (web twin of mobile WELCOME_DETAILS.welcomeModalTitle;
// title matches the mobile brand config so the greeting is identical cross-platform).
export const WELCOME_DETAILS = {
    welcomeModalTitle: 'Welcome to FINRA Securities Exam Prep!',
};
